<template>
  <div class="contact-wrapper">
    <div class="contact-wrapper_info info">
      <h2 class="info-header">Contact</h2>
      <div class="info-wrapper">
        <div class="info-wrapper_item">
          <h3>Phone</h3>
          <span>666 555 045</span>
        </div>
        <div class="info-wrapper_item">
          <h3>Email</h3>
          <span>hub.ladzinski@gmail.com</span>
        </div>
      </div>
    </div>
    <div class="contact-wrapper_form form-wrapper">
      <h2>Send me a message</h2>
      <form class="form" v-on:submit.prevent="sendMessage">
        <div class="form_input" id="input1">
          <label for="name">Name</label>
          <input id="name" type="text" required />
        </div>
        <div class="form_input" id="input2">
          <label for="email">Email</label>
          <input id="email" type="email" required />
        </div>
        <div class="form_input last">
          <label for="message">Message</label>
          <textarea id="message" required />
        </div>
        <div class="form_button">
          <button id="project-button">
            Send
          </button>
        </div>
      </form>
    </div>
    <button
      class="message-send-popup hidden"
      v-bind:class="{ transition: doTransition }"
      id="message-send-popup"
      @click="doTransition = false"
    >
      {{ responseMessage }}
    </button>
  </div>
</template>

<script>
import { sendMessageToDB } from "../firebase";

export default {
  name: "Contact",
  data() {
    return {
      responseMessage: null,
      doTransition: false,
    };
  },
  methods: {
    sendMessage() {
      const nameValue = document.querySelector("#name").value;
      const emailValue = document.querySelector("#email").value;
      const messageValue = document.querySelector("#message").value;

      const messageObject = {
        name: nameValue,
        email: emailValue,
        message: messageValue,
        date: new Date(Date.now()),
      };

      sendMessageToDB(messageObject)
        .then((response) => {
          console.log(response);
          if (response) {
            this.responseMessage = "Wiadomość wysłana";
            this.doTransition = true;
          } else {
            this.responseMessage = "Błąd wysyłania wiadomości";
            this.doTransition = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.responseMessage = "Błąd wysyłania wiadomości";
          this.doTransition = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/_extensions.scss";
@import "../scss/_variables.scss";

@font-face {
  font-family: Gilroy;
  src: url("../assets/Gilroy-Light.otf") format("opentype");
}

.contact-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 50px;
  margin-top: 20px;

  &_form {
    margin-top: 35px;
    padding: 0 23px;

    @media screen and (min-width: 850px) {
      padding: 0 60px;
    }
  }
}

.info {
  background-color: rgba($color: #4b5aff, $alpha: 0.04);
  padding: 40px 23px;

  @media screen and (min-width: 850px) {
    padding: 60px;
  }
  &-header {
    font-size: 3.2rem;
    font-family: "Gilroy", sans-serif;

    @media screen and (min-width: 850px) {
      font-size: 5.5rem;
    }
  }

  &-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: 850px) {
      flex-direction: row;
      justify-content: space-around;
    }

    &_item {
      margin-top: 50px;
      h3 {
        font-size: 1.8rem;
        font-family: "Gilroy", sans-serif;
        text-align: center;

        @media screen and (min-width: 850px) {
          font-size: 2.8rem;
        }
      }
      span {
        display: block;
        font-size: 2.5rem;
        font-family: "Arial", sans-serif;
        margin-top: 14px;

        @media screen and (min-width: 850px) {
          font-size: 3.8rem;
          margin-top: 28px;
        }
      }
    }
  }
}

.form-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 3.2rem;
    font-family: "Gilroy", sans-serif;

    @media screen and (min-width: 850px) {
      font-size: 5.5rem;
    }
  }

  form {
    margin-top: 25px;
  }
}

.form {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;

  @media screen and (min-width: 850px) {
    display: grid;
    gap: 0 50px;
    justify-content: center;
    align-items: center;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "input1 message"
      "input2 message"
      "button .     ";
  }

  &_input {
    margin-top: 10px;

    label {
      font-size: 1.5rem;
      font-family: "Arial", sans-serif;
    }
    input {
      border: 1px solid black;
      width: 100%;
      height: 50px;
      margin-top: 10px;
    }
    textarea {
      border: 1px solid black;
      min-height: 150px;
      width: 100%;
      margin-top: 10px;

      @media screen and (min-width: 850px) {
        height: 176px;
      }
    }
  }

  &_button {
    button {
      @extend %button-default;
      width: 100%;
      margin-top: 20px;
      cursor: pointer;
    }
    @media screen and (min-width: 850px) {
      grid-area: button;
      width: 180px;
    }
  }
}

#input1 {
  @media screen and (min-width: 850px) {
    grid-area: input1;
  }
}

#input2 {
  @media screen and (min-width: 850px) {
    grid-area: input2;
  }
}

.last {
  flex: 1;

  @media screen and (min-width: 850px) {
    grid-area: message !important;
  }
}

.message-send-popup {
  position: fixed;
  bottom: -300px;
  margin-left: calc(50% - 175px);
  background-color: #f8f9ff;
  height: 75px;
  width: 350px;
  font-family: "Gilroy", sans-serif;
  border: none;
  cursor: pointer;
  box-shadow: 0 7px 20px 5px rgba(0, 0, 0, 0.2);
  font-size: 18px;
  text-align: center;
  font-weight: 300;
  letter-spacing: 2px;
  text-transform: uppercase;
  transition: bottom 1s;
}
.message-send-popup.transition {
  bottom: 50vh !important;
}
</style>
